export default __webpack_public_path__ + "static/media/DOM-APR2026.87cb498a.png";